export enum BackgroundType {
  classic = 'classic',
  modern = 'modern',
  minimal = 'minimal',
  theme = 'theme'
}

export interface ThemeConfig {
  backgroundType: BackgroundType;
  graphicAccent: string;
  supportsTranslucentEffect: boolean;
  supportsSuggestedBackgroundColor: boolean;
  suggestedBackgroundColor: string;
}

const THEME_LAYOUT_CONFIGS: {
  [theme: string]: ThemeConfig;
} = {
  earthly_organic: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'gold_hearts'
  },
  elegant_industrial: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: true,
    suggestedBackgroundColor: '#f8f7f5',
    graphicAccent: 'diamonds'
  },
  muted_floral: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: true,
    suggestedBackgroundColor: '#f2ebe9',
    graphicAccent: 'muted_floral'
  },
  golden_haze: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'gold_hearts'
  },
  alpine_wreath: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'alpine_wreath'
  },
  blush_muted_floral: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'muted_floral'
  },
  bohemian_floral: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'bohemian_floral'
  },
  branching_out: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'branching_out'
  },
  bronzed_leaves: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'bronzed_leaves'
  },
  bronze_floral_frame: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'bronze_floral_frame'
  },
  calligraphic_botanical: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'calligraphic_botanical'
  },
  cascading_altar: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'cascading_altar'
  },
  classic_linen: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: true,
    suggestedBackgroundColor: '#570F40',
    graphicAccent: 'standard_1'
  },
  cosmic_night: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_6'
  },
  cotton_candy: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_1'
  },
  crystal_dawn: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: true,
    suggestedBackgroundColor: '#AEAFC3',
    graphicAccent: 'standard_3'
  },
  crystal_dusk: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: true,
    suggestedBackgroundColor: '#564454',
    graphicAccent: 'standard_3'
  },
  dark_thorn: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_12'
  },
  dream_wash: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'feather'
  },
  elegance: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_10'
  },
  elegant_eucalyptus: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'natural_laurel'
  },
  elegant_oasis: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'elegant_oasis'
  },
  elegant_paper: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_9'
  },
  fern_botanical: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: true,
    suggestedBackgroundColor: '#F2EEE2',
    graphicAccent: 'fern_botanical'
  },
  floral_bouquet: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'branch_0'
  },
  gold_vines: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'gold_vines'
  },
  graphite: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'hearts'
  },
  illustrated_book: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'lavender'
  },
  lavender_sage: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'lavender'
  },
  lush_greenery: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'lush_greenery'
  },
  metallic_wreath: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'metallic_wreath'
  },
  midnight_peony: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'midnight_peony'
  },
  mod_marble: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'arrow'
  },
  modern_brushstrokes: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_5'
  },
  modern_marble: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_5'
  },
  natural_laurel: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'natural_laurel'
  },
  northwest: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'feather_2'
  },
  painted_pink: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'gold_hearts'
  },
  painterly_bloom: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'painterly_bloom'
  },
  painterly_bohemian: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'lavender'
  },
  painterly_gem: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_1'
  },
  palace: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_1'
  },
  porcelain_breeze: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_0'
  },
  romantic_succulents: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'romantic_succulents'
  },
  romantic_garland: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'romantic_garland'
  },
  rustic_elegance: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'rustic_elegance'
  },
  rustic_wreath: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'rustic_wreath'
  },
  sea_salt: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'seaweed_2'
  },
  silver_haze: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: true,
    suggestedBackgroundColor: '#2d2d2d',
    graphicAccent: 'standard_4'
  },
  simple_rustic: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'branch_0'
  },
  star_gazing: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'star_gazing'
  },
  strung_in_love: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'standard_5'
  },
  strung_lights: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'strung_lights'
  },
  victorian: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: true,
    suggestedBackgroundColor: '#FCF8F6',
    graphicAccent: 'victorian'
  },
  vintage_mountain: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'arrow'
  },
  watercolor_beach: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'shell_1'
  },
  watercolor_cactus: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'watercolor_cactus'
  },
  we_do: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: true,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'diamonds'
  },
  wonderferris: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'wonderferris'
  },
  woodgrain_lace: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'woodgrain_lace'
  },
  wreath: {
    backgroundType: BackgroundType.theme,
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '',
    graphicAccent: 'alpine_wreath'
  },
  default: {
    backgroundType: BackgroundType.classic,
    graphicAccent: 'standard_1',
    supportsTranslucentEffect: false,
    supportsSuggestedBackgroundColor: false,
    suggestedBackgroundColor: '#fff'
  }
};

export { THEME_LAYOUT_CONFIGS };
